import React from 'react'
import { AuthenticationInputPropTypes } from 'utils/prop_types/AuthenticationInput'
import Validator from 'utils/Validator'

import { InputGroup } from 'components/qstrap'
import ErrorInfo from 'components/shared/input/ErrorInfo'
import Label from 'components/shared/input/Label'
import TextInput from 'components/shared/input/TextInput'
import PasswordInput from 'components/shared/input/PasswordInput'
import RadioInput from 'components/shared/input/RadioInput'
import SelectInput from 'components/shared/input/SelectInput'
import SelectButtonInput from 'components/shared/input/SelectButtonInput'

export default class Input extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      clientSideErrors: [],
    }

    this.value = this.props.defaultValue
    this.validate = this.validate.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  validationClassName() {
    if (this.validity() === undefined) return ''
    return this.validity() ? '' : 'invalid'
  }

  validate() {
    // if value is undefined, change that to empty string, to "force" validate
    // since undefined means is => initial value when user come at fist time to the page
    // so skipped by validation
    if (this.value === undefined) this.value = this.state.value || this.props.defaultValue || ''
    const clientSideErrors = Validator.validate(this.value, this.props.validations)
    this.setState({ clientSideErrors })

    return clientSideErrors.length === 0
  }

  handleChange(e) {
    this.value = e.target.value
    this.validate()
    if (this.props.callback) this.props.callback(this.validity(), this.value)
  }

  validity() {
    if (this.value !== undefined) return this.state.clientSideErrors.length === 0
    return this.value
  }

  renderByType() {
    switch (this.props.type) {
      case 'password':
        return (
          <PasswordInput
            {...this.props}
            ref={(element) => { this.inputTag = element }}
            handleChange={this.handleChange}
            inputTag={this.inputTag}
            valid={this.validity()}
          />
        )
      case 'select':
        return (
          <SelectInput
            {...this.props}
            ref={(element) => { this.inputTag = element }}
            inputTag={this.inputTag}
            valid={this.validity()}
            data={this.props.selectOptions || []}
            handleChange={this.handleChange}
          />
        )
      case 'selectButton':
        return (
          <SelectButtonInput
            {...this.props}
            handleChange={this.handleChange}
            valid={this.validity()}
          />
        )
      case 'radioButton':
        return (
          <RadioInput
            {...this.props}
            ref={(element) => { this.inputTag = element }}
            handleChange={this.handleChange}
            inputTag={this.inputTag}
            valid={this.validity()}
          />
        )
      default:
        return (
          <TextInput
            {...this.props}
            defaultValue={this.state.value || this.props.defaultValue}
            ref={(element) => { this.inputTag = element }}
            handleChange={this.handleChange}
            inputTag={this.inputTag}
            valid={this.validity()}
          />
        )
    }
  }

  render() {
    return (
      <div className={`form-group input-extended ${this.validationClassName()} ${this.props.containerClassName || ''}`}>
        <Label text={this.props.label} name={this.props.name} />
        <InputGroup className={`input-group-${this.props.type}`}>
          {this.renderByType()}
        </InputGroup>
        <ErrorInfo enabled={this.props.embedErrorsInfo} errors={this.state.clientSideErrors} field={this.props.name} />
      </div>
    )
  }
}

Input.propTypes = AuthenticationInputPropTypes
Input.defaultProps = {
  type: 'text',
  validations: [],
  selectOptions: [],
}
